/* global globalThis */
// Хранилище планов раунда новой архитектуры (см.
// developer_artifacts/bot_strategy/new_arch_plan.md).
import {selectGameType, selectIsBotsPlannerModeEnabled,} from "../../../redux/reducers/sharedStateReducer/selectors";
import {GAME_TYPES} from "../../../constants/game";

export const isPlannerPlayer = (playerId) =>
  Boolean(globalThis.__plannerPlayerIds && globalThis.__plannerPlayerIds.has(playerId));

/**
 * Режим планировщика для бота: {enabled, rollouts}.
 *
 * В A/B-симуляциях набор __plannerPlayerIds задан харнессом и решает всё
 * (роллауты — по __plannerRollouts, как раньше).
 *
 * ПРОД (решение пользователя 2026-08-16): планировщик ПО УМОЛЧАНИЮ ВЫКЛЮЧЕН
 * ВЕЗДЕ. Включается только в локальной партии админским тумблером на
 * HotSeatPlayersInitPage (plannerBotsEnabled в shared gameState). Демо меню
 * сбрасывает флаг явно; сетевые игры отсечены проверкой типа игры (включение
 * в онлайне — отдельное задание:
 * developer_artifacts/tasks/planner_shared_plan_online.md).
 */
export const getPlannerMode = (state, playerId) => {
  if (globalThis.__plannerPlayerIds) {
    const enabled = globalThis.__plannerPlayerIds.has(playerId);
    return {enabled, rollouts: enabled && Boolean(globalThis.__plannerRollouts)};
  }
  const enabled = selectGameType(state) === GAME_TYPES.LOCAL
    && selectIsBotsPlannerModeEnabled(state);
  return {enabled, rollouts: enabled};
};

// playerId -> {round, plan}
const plansByPlayerId = new Map();

export const getCachedRoundPlan = (playerId, round) => {
  const entry = plansByPlayerId.get(playerId);
  return entry && entry.round === round ? entry.plan : null;
};

export const setCachedRoundPlan = (playerId, round, plan) => {
  plansByPlayerId.set(playerId, {round, plan});
};

// Сброс при старте новой партии (вызывается вместе с clearBotPredictions)
export const clearPlannerPlans = () => {
  plansByPlayerId.clear();
};
